import { IEmployeeExperienceContext } from '@micro-frontend-react/employee-experience/lib/IEmployeeExperienceContext';
import { useContext, useEffect, useState, Context as ReactContext } from 'react';
import { Context } from '@micro-frontend-react/employee-experience/lib/Context';
import { DataOwnerRecord } from '../../Common/DataOwnerModels/DataOwnerRecord';

export function useGetAllDataOwners(shouldReload: boolean) {
  const [dataownerList, setDataOwnerList] = useState<DataOwnerRecord[]>(null);
  const [dataownerListLoading, setDataOwnerListLoading] = useState<boolean>(true);
  const { httpClient } = useContext(Context as ReactContext<IEmployeeExperienceContext>);

  useEffect(() => {
    /*
      Checking for false boolean because it reloads twice when shouldReload mutates
      false -> true -> false
    */

    if (!shouldReload) {
      setDataOwnerListLoading(true);
      httpClient
        .get<DataOwnerRecord[]>(`${__API_BASE_URL__}/tenant/getAllTenants`, {
          resource: __CLIENT_ID__,
          headers: {
            'Content-Type': 'application/json',
            'X-Content-Type-Options': 'nosniff',
          },
        })
        .then(({ data }) => {
          setDataOwnerList(data);
          setDataOwnerListLoading(false);
        });
    }
  }, [shouldReload]);

  return [dataownerList, dataownerListLoading] as const;
}
